import styled from 'styled-components';
import { Container, Col, FormGroup } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
export const StyledContainer = styled(Container)`
  background: #f9f9fb;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
`;

export const BannerWrapper = styled.div`
  width: 210px;
`;

export const StyledFormGroup = styled(FormGroup)`
  fieldset {
    width: 100% !important;
  }
`;

export const StyledRadioLabel = styled.label`
  margin: 0px 8px;
  color: #33373d;
`;

export const StyledCancelButton = styled(Button)`
  color: #000000 !important;
  background-color: #ffffff !important;
  &:hover,
  &:active {
    box-shadow: none !important;
  }
  &:focus {
    box-shadow: none !important;
  }
`;
